var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 4.5H19V2C19 0.896875 18.1031 0 17 0H7C5.89687 0 5 0.896875 5 2V4.5H1C0.446875 4.5 0 4.94688 0 5.5V6.5C0 6.6375 0.1125 6.75 0.25 6.75H2.1375L2.90938 23.0938C2.95938 24.1594 3.84063 25 4.90625 25H19.0938C20.1625 25 21.0406 24.1625 21.0906 23.0938L21.8625 6.75H23.75C23.8875 6.75 24 6.6375 24 6.5V5.5C24 4.94688 23.5531 4.5 23 4.5ZM16.75 4.5H7.25V2.25H16.75V4.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.88d4e4d96ad9b8abe0f8c9fe6be44ccb.svg";
export { ForwardRef as ReactComponent };